export default function ChartEmptyState() {
  return (
    <div className="rounded-3xl border border-dashed border-neutral-300 bg-neutral-50 px-6 py-14 text-center">
      <h3 className="text-2xl font-black text-neutral-950">No comparable public data is available yet</h3>
      <p className="mx-auto mt-3 max-w-2xl text-base leading-7 text-neutral-600">
        This chart remains empty rather than displaying estimates, placeholder zeros or measurements collected under incompatible conditions.
      </p>
    </div>
  );
}
